import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { WebusersComponent } from './pages/administration/webusers/webusers.component';
import { WebusersManageComponent } from './pages/administration/webusers/webusers-manage/webusers-manage.component';
import { ROTEReportsComponent } from './pages/reports/rote/rote-reports.component';
import { AssetRegisterComponent } from './pages/reports/asset-register/asset-register.component';
import { AssetManagementComponent } from './pages/administration/asset-management/asset-management.component';
import { AssetManageComponent } from './pages/administration/asset-management/asset-manage/asset-manage.component';
import { JobManageComponent } from './pages/administration/job-management/job-manage/job-manage.component';
import { JobManagementComponent } from './pages/administration/job-management/job-management.component';
import { JobReportComponent } from './pages/reports/job-reports/job-reports.component';
import { EngineersManageComponent } from './pages/administration/engineers/engineers-manage/engineers-manage.component';
import { EngineerComponent } from './pages/administration/engineers/engineers.component';



const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  {
    path: 'reports', children: [
      { path: '', component: ROTEReportsComponent },
      { path: 'rote', component: ROTEReportsComponent },
      { path: 'asset-register', component: AssetRegisterComponent },
      { path: 'job-reports', component: JobReportComponent }
    ]
  },
  {
    path: 'admin', children: [
      {
        path: 'assets', children: [
          { path: '', component: AssetManagementComponent },
          { path: 'manage', component: AssetManageComponent },
          { path: 'manage/:id', component: AssetManageComponent }
        ]
      },
      {
        path: 'jobs', children: [
          { path: '', component: JobManagementComponent },
          { path: 'manage', component: JobManageComponent },
          { path: 'manage/:id', component: JobManageComponent }
        ]
      },
    ]
  },

  {
    path: 'users', children: [
      { path: '', component: WebusersComponent },
      { path: 'manage', component: WebusersManageComponent },
      { path: 'manage/:id', component: WebusersManageComponent }
    ]
  },
  {
    path: 'engineers', children: [
      { path: '', component: EngineerComponent },
      { path: 'manage', component: EngineersManageComponent },
      { path: 'manage/:id', component: EngineersManageComponent }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
